module.exports = __webpack_public_path__ + "img/checkmark.5a96e028.svg";